import { useAuthStore } from "../stores/authStore";

export const useAttributes = () =>
  useAuthStore((state) =>
    state.status === "loading" ? null : state.session.attributes,
  );
